import React, { useEffect, useState } from "react";
import { useBuilding } from "../../context/BuildingContext";
import { reportsApi } from "../../services/api";
import GenericReportViewer from "./GenericReportViewer";

interface Props {
  period: string;
}

const AuditTrailReport: React.FC<Props> = ({ period }) => {
  const { currentBuilding } = useBuilding();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [report, setReport] = useState<any>(null);

  useEffect(() => {
    if (!currentBuilding?.id) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await reportsApi.getAuditTrail(currentBuilding.id, {
          period,
        });
        if (!cancelled) setReport(data);
      } catch (e) {
        console.error(e);
        if (!cancelled) setError("Failed to load audit trail.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [currentBuilding?.id, period]);

  return (
    <GenericReportViewer
      title="Audit Trail"
      loading={loading}
      error={error}
      report={report}
      emptyMessage="No audit log entries recorded yet."
    />
  );
};

export default AuditTrailReport;
